import type { SVGProps } from "react";
import logo from "../assets/new-logo.png";
import { useLang } from "../i18n/LanguageContext";

// lucide-react dropped brand logos, so these stay as inline SVGs.
const FacebookIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M10.4375 21.8784C5.65941 21.1274 2 16.9877 2 12 2 6.48086 6.48086 2 12 2c5.5191 0 10 4.48086 10 10 0 4.9877-3.6594 9.1274-8.4375 9.8784v-6.9878h2.3301L16.3359 12h-2.7734v-1.8758c0-.79084.3874-1.5617 1.6296-1.5617h1.261V6.10156s-1.1443-.19531-2.2385-.19531c-2.2842 0-3.7771 1.38438-3.7771 3.89063V12H7.89844v2.8906h2.53906v6.9878Z"
      clipRule="evenodd"
    />
  </svg>
);

const LinkedinIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
  </svg>
);

const socials = [
  {
    Icon: FacebookIcon,
    label: "Facebook",
    href: "https://facebook.com/profile.php?id=100094712741741",
  },
  {
    Icon: LinkedinIcon,
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/rashad-for-legal-services/",
  },
];

export function Footer() {
  const { t } = useLang();
  return (
    <footer className="relative border-t border-primary/15 bg-cream px-6 lg:px-24">
      <div className="container mx-auto py-12 lg:py-16">
        <div className="flex flex-col items-center gap-10 lg:flex-row lg:justify-between">
          {/* Brand */}
          <div className="flex flex-col items-center gap-4 lg:items-start">
            <img src={logo} alt={t.footer.companyName} style={{ maxWidth: 130 }} />
            <p className="max-w-xs text-center text-sm text-primary/60 lg:text-left rtl:lg:text-right">
              {t.footer.tagline}
            </p>
          </div>

          {/* Socials */}
          <div className="flex items-center gap-4">
            {socials.map(({ Icon, label, href }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noreferrer"
                aria-label={label}
                className="grid h-12 w-12 place-items-center rounded-full border border-secondary/40 text-secondary transition-colors hover:bg-secondary hover:text-white"
              >
                <Icon className="h-5 w-5" />
              </a>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center gap-2 border-t border-primary/10 pt-6 text-center text-xs text-primary/50">
          <span>
            © {new Date().getFullYear()} {t.footer.companyName}. {t.footer.rights}
          </span>
        </div>
      </div>
    </footer>
  );
}
